import { styled, css } from 'styled-components';

export const Container = styled.div<{ $type?: 'danger' | 'info' }>`
  ${({ theme: { borderRadius, colors }, $type = 'danger' }) => css`
    border-radius: ${borderRadius.sm};
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    margin: 0 0.5rem 0.5rem;

    ${
      $type === 'danger' &&
      css`
        background: ${colors.semanticDangerTint90};
        color: ${colors.semanticDangerShade20};
      `
    }

    ${
      $type === 'info' &&
      css`
        background: ${colors.brandDarkTint95};
        color: ${colors.brandDark};
      `
    };
  `}
`;

export const Feedback = styled.div`
  ${({ theme: { fontSizes } }) => css`
    border-radius: 4px;
    font-size: ${fontSizes.s12};
    line-height: 1.2em;
  `}
`;

export const Row = styled.div`
  ${({ theme: { colors, fontSizes } }) => css`
    align-items: center;
    display: flex;
    justify-content: space-between;

    p {
      color: ${colors.brandDarkTint20};
      font-size: ${fontSizes.s12};
      margin: 0;
    }
  `}
`;

export const Group = styled.div`
  ${({ theme: { colors } }) => css`
    align-items: center;
    display: flex;
    gap: 0.25rem;

    .button {
      height: 1.5rem;
      min-width: 1.5rem;
      width: 1.5rem;

      .icon {
        height: 0.75rem;
        width: 0.75rem;
      }

      &:disabled {
        background: transparent;
        border-color: ${colors.brandDarkAlpha10};
      }
    }
  `}
`;
